import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import { CONSTANT_VALUE, CONSTANT_MESSAGE } from "@/lookups.data";
import { getEncryptedData } from "@/services/custom.js";
import { apiurl } from "@/store/modules/apiurl";
import BaseService from "@/services/BaseService";
import moment from "moment";

export const serialize = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};
export const printPdfPreview = async (
  _key,
  query = null,
  id = null,
  fileName = '',
  requestMethod = '',
  data = [],
) => {
  let _url = apiurl[_key];
  if (id) _url += `/${id}`;

  if (typeof query == 'object') {
    if (query) _url += `?${serialize(query)}`;
  } else {
    if (query) _url += `${query}`;
  }

  // _url = decodeURIComponent(_url);
  if (data) data;
  let _reMethod = 'GET';
  if (requestMethod) {
    _reMethod = requestMethod.toString();
  }
  let object = {
    url: _url,
    method: _reMethod,
    params: { data: data },
    responseType: 'blob', // important
  };
  try{
    const response = await BaseService.getSchemePlanningClient().get(_url, {
      params: { data: data },
      responseType: "blob",
    });
// return axios(object)
  // .then(response => {
    const pdfFile = new Blob([response.data], {
      type: 'application/pdf',
    });
    const pdfURL = window.URL.createObjectURL(pdfFile);
    return pdfURL;
  // })
    } catch (err) {
  // .catch(async err => {
    let errorString = err;

    if (
      err.request.responseType === 'blob' &&
      err.response.data instanceof Blob &&
      err.response.data.type &&
      err.response.data.type.toLowerCase().indexOf('json') != -1
    ) {
      errorString = 'Getting error while generating letter. Please check the plan definition.';
      // errorString = JSON.parse(await err.response.data.text());
      throw errorString;
    }
    // this.$showSnackbar({
    //   text: msg.somethingWrong,
    // });
  // });
    }
};
export const triggerExport = async (
  _key,
  query = null,
  id = null,
  fileName = "",
  requestMethod = "",
  data = []
) => {
  let _url = apiurl[_key];
  if (id) _url += `/${id}`;

  if (typeof query == "object") {
    if (query) _url += `?${serialize(query)}`;
  } else {
    if (query) _url += `${query}`;
  }

  // _url = decodeURIComponent(_url);
  if (data) data;
  let _reMethod = "GET";
  if (requestMethod) {
    _reMethod = requestMethod.toString();
  }

  let object = {
    url: _url,
    method: _reMethod,
    params: { data: data },
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    responseType: "blob", // important
  };
  // if (_reMethod == 'POST') {
  //   object.data = data;
  //   delete object.params;
  // } else {
  //   delete object.params;
  // }

  const response = await BaseService.getSchemePlanningClient().get(_url, {
    params: { data: data },
    responseType: "blob",
  });

  try {
    const timestamp = new Date().getTime();
    if (!window.navigator.msSaveOrOpenBlob) {
      // BLOB NAVIGATOR
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("id", timestamp);
      link.setAttribute("download", fileName || "export.xlsx");
      document.body.appendChild(link);
      const ele = document.getElementById(timestamp);
      ele.click();
      setTimeout(() => ele.remove(), 1000);
      return false;
    } else {
      // BLOB FOR EXPLORER 11
      const url = window.navigator.msSaveOrOpenBlob(
        new Blob([response.data]),
        fileName || "export.xlsx"
      );
      return false;
    }
  } catch (err) {
    let errorString = err;
    if (
      err.request.responseType === "blob" &&
      err.data instanceof Blob &&
      err.data.type &&
      err.data.type.toLowerCase().indexOf("json") != -1
    ) {
      errorString = JSON.parse(await err.data.text());
      throw errorString;
    }
  }

  // return axios(object)
  //   .then(response => {
  //     const timestamp = new Date().getTime();
  //     if (!window.navigator.msSaveOrOpenBlob) {
  //       // BLOB NAVIGATOR
  //       const url = window.URL.createObjectURL(new Blob([response.data]));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('id', timestamp);
  //       link.setAttribute('download', fileName || 'export.xlsx');
  //       document.body.appendChild(link);
  //       const ele = document.getElementById(timestamp);
  //       ele.click();
  //       setTimeout(() => ele.remove(), 1000);
  //       return false;
  //     } else {
  //       // BLOB FOR EXPLORER 11
  //       const url = window.navigator.msSaveOrOpenBlob(
  //         new Blob([response.data]),
  //         fileName || 'export.xlsx',
  //       );
  //       return false;
  //     }
  //   })
  //   .catch(async err => {
  //     let errorString = err;
  //     if (
  //       err.request.responseType === 'blob' &&
  //       err.data instanceof Blob &&
  //       err.data.type &&
  //       err.data.type.toLowerCase().indexOf('json') != -1
  //     ) {
  //       errorString = JSON.parse(await err.data.text());
  //       throw errorString;
  //     }
  //     // this.$showSnackbar({
  //     //   text: msg.somethingWrong,
  //     // });
  //   });
};
export default {
  data() {
    return {
      textValidateRuleWithRequired: [
        (v) => !!v || "Required field",
        (v) => this.validationSpecialCharacter(v),
      ],
      textValidateRuleWithoutRequired: [
        (v) => this.validationSpecialCharacter(v),
      ],
      textValidateRuleWithRequiredRemovingSlash: [
        (v) => !!v || "Required field",
        (v) => this.validationSpecialCharacterRemovingSlash(v),
      ],
      // textValidationPlanning: [
      //   (v) => !!v || "Required field",
      //   (v) => this.schemePlanningInputValidation(v),
      // ],
      validateFileRule: [(v) => !!v || "Please upload a file"],
      requiredValidationRule: [
        (v) => {
          return !!v || "Required field";
        },
      ],
      multiDropdownValidateRule: [(v) => !!v.length || "Required field"],
      validateNonDecimalRule: [
        (v) => {
          const expression = /^[0-9]+$/;
          return expression.test(v) || "Decimal values are not allowed";
        },
      ],
      nameCounter: 1,
    };
  },
  computed: {
    ...mapGetters("sisSchemePlanning", ["getCreateSchemeForm"]),
   
    /** Hide the save button for scheme plan */
    canHideSchPlanGlbSaveButton() {
      if (
        this?.getCreateSchemeForm?.general?.editAllowed ==true
      )
      return true;
      if (
        Object.keys(this.getCreateSchemeForm).length &&
        Object.keys(this.getCreateSchemeForm.general).length &&
        this.getCreateSchemeForm.general != undefined &&
        this.getCreateSchemeForm.general.revisionStatus != CONSTANT_VALUE.schPlan_draft
      ) {
        return false;
      }
      return true;
    },

    /** Hide the save button for Trade plan*/
    canHideTradePlanGlbSaveButton() {
      if (
        Object.keys(this.getTradePlan).length &&
        Object.keys(this.getTradePlan.headerForm).length &&
        this.getTradePlan.headerForm != undefined &&
        this.getTradePlan.headerForm.tradePlanStatus !=
          CONSTANT_VALUE.TRADE_PLAN_DRAFT
      ) {
        return false;
      }
      return true;
    },

    dateDetails() {
      const dateObj = new Date(this.getTradePlan.headerForm.fromDate);
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];
      // Get the current year and month
      const year = dateObj.getFullYear();
      const monthIndex = dateObj.getMonth();
      const monthName = monthNames[monthIndex];

      // Get last year same month
      const lastYear = year - 1;
      const lastYearSameMonth = monthNames[monthIndex];

      // Get the previous month (if monthIndex is 0, go to last month of previous year)
      const previousMonthIndex = (monthIndex - 1 + 12) % 12;
      const previousMonthName = monthNames[previousMonthIndex];
      const pastYearIfNeeded = monthIndex === 0 ? year - 1 : year;

      // Get the month before the previous month
      const pastOneMonthIndex = (monthIndex - 2 + 12) % 12;
      const pastOneMonthName = monthNames[pastOneMonthIndex];

      // Get two months before the previous month
      const pastTwoMonthIndex = (monthIndex - 3 + 12) % 12;
      const pastTwoMonthName = monthNames[pastTwoMonthIndex];

      // Get three months before the previous month
      const pastThreeMonthIndex = (monthIndex - 4 + 12) % 12;
      const pastThreeMonthName = monthNames[pastThreeMonthIndex];

      // Return an object with all the required date formats
      return {
        current_month: `[${monthName}-${year}]`,
        last_year_same_month: `[${lastYearSameMonth}-${lastYear}]`,
        current_year_previous_month: `[${previousMonthName}-${pastYearIfNeeded}]`,
        current_year_past_one_month: `[${pastOneMonthName}-${pastYearIfNeeded}]`,
        current_year_past_two_months: `[${pastTwoMonthName}-${pastYearIfNeeded}]`,
        current_year_past_three_months: `[${pastThreeMonthName}-${pastYearIfNeeded}]`,
      };
    },
    
  },
  methods: {
    ...mapActions(["setLoader", "setSnackbar"]),
    ...mapActions("sisSchemePlanning", ["downloadLettterPreviewPdf"]),
    checkGridPastData(combineData) {
      const reqData = Array.from(
        new Set(combineData.map((obj) => obj.key))
      ).map((key) => {
        return combineData.find((obj) => obj.key === key);
      });
      return reqData;
    },
    validateToDate(fromDate) {
      return [
        (v) => !!v || "Required field",
        (v) => {
          this.$refs[fromDate].validate();
          return (
            new Date(v) > new Date(this.$refs[fromDate].value) ||
            "To date must be greater than From date"
          );
        },
      ];
    },
    validateMaxPrice(minPrice) {
      return [
        (v) => !!v || "Required field",
        (v) => {
          return (
            parseFloat(v) > parseFloat(this.$refs[minPrice].value) ||
            "Max price should be greater than Min price"
          );
        },
      ];
    },
    validateRatio(ref) {
      return [
        (v) => !!v || "Required field",
        (v) => {
          const expression = /^[0-9]+$/;
          return expression.test(v) || "Decimal values are not allowed";
        },
        (v) => {
          if (!this.$refs[ref].value) return true;
          if (ref === "leftRatioRef") {
            return (
              parseFloat(v) <= parseFloat(this.$refs[ref].value) ||
              "Left ratio should be greater than right ratio"
            );
          } else {
            return (
              parseFloat(v) >= parseFloat(this.$refs[ref].value) ||
              "Right ratio should be less than Left ratio"
            );
          }
        },
      ];
    },
    validateFields(refs) {
      for (let ref in refs) {
        if (
          ref != "file" &&
          ref != "modal" &&
          ref != "upload" &&
          ref != "grid"
        ) {
          try {
            this.$refs[ref].validate();
          } catch (e) {
            continue;
          }
        }
      }
    },
    validateFileType(files) {
      const type = files[0].type;
      if (type == "text/csv") {
        return true;
      }
      return false;
    },
    validationSpecialCharacter(v) {
      const expression = /^[a-zA-Z0-9-_\s]+$/;
      return expression.test(v) || "No special characters allowed";
    },
    validationSpecialCharacterRemovingSlash(v) {
      const expression = /^[A-Za-z0-9 _-]+$/;
      return expression.test(v) || "No special characters allowed";
    },
    // schemePlanningInputValidation(v) {
    //   const expression = /^[a-zA-Z0-9^\\[\\s+.*\\]$-_()%*#,/\\\\]*$/
    //   return (
    //     true ||
    //     "only these ()[]%/_*,- special characters are allowed"
    //   );
    // },
    formateDate(date, format = true) {
      const dateObject = date ? new Date(date) : new Date();
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Adding 1 to month as it is zero-indexed
      const day = String(dateObject.getDate()).padStart(2, "0");
      const formattedDate = format
        ? `${year}/${month}/${day}`
        : `${year}-${month}-${day}`;
      return formattedDate;
    },
    clearValidationComp(refs) {
      this.$nextTick(() => {
        for (let ref in refs) {
          try {
            this.$refs[ref].clearValidation();
          } catch (err) {
            continue;
          }
        }
      });
    },
    commonExportCSV(response, fileName) {
      const timestamp = new Date().getTime();
      if (!window.navigator.msSaveOrOpenBlob) {
        // BLOB NAVIGATOR
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("id", timestamp);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        const element = document.getElementById(timestamp);
        element.click();
        setTimeout(() => element.remove(), 1000);
        return false;
      } else {
        const url = window.navigator.msSaveOrOpenBlob(
          new Blob([response.data]),
          fileName
        );
        return false;
      }
    },
    commonTestPdf(response, fileName) {
      const timestamp = new Date().getTime();
      if (!window.navigator.msSaveOrOpenBlob) {
        // BLOB NAVIGATOR
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("id", timestamp);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        const element = document.getElementById(timestamp);
        element.click();
        setTimeout(() => element.remove(), 1000);
        return false;
      } else {
        const url = window.navigator.msSaveOrOpenBlob(
          new Blob([response.data]),
          fileName
        );
        return false;
      }
    },
    downloadPdf(payload) {
      this.setLoader(true);
      this.downloadLettterPreviewPdf(payload)
        .then((resp) => {
          this.setLoader(false);
          let fileName = `${payload.plan}.pdf`;
          this.commonTestPdf(resp, fileName);
          this.setSnackbar({
            active: true,
            msg: `SUCCESS`,
          });
        })
        .catch((err) => {
          this.setLoader(false);
          this.setSnackbar({
            active: true,
            msg: `Getting error while generating letter. Please check the plan definition.`,
          });
        });
    },
    validateToDatePlanning(fromDate) {
      return [
        (v) => !!v || "Required field",
        (v) => {
          this.$refs[fromDate].validate();
          return (
            new Date(v) >= new Date(this.$refs[fromDate].value) ||
            "To date must be greater than or equal to the from date"
          );
        },
      ];
    },
    filterEncryptedData(f, page) {
      if (f.length > 0) {
        let enryptEncRecord = "";
        f.map((o) => {
          enryptEncRecord = enryptEncRecord
            ? enryptEncRecord + "::" + o.value + "::" + o.data
            : o.value + "::" + o.data;
          axios.defaults.headers.common["filterEnc"] =
            getEncryptedData(enryptEncRecord);
        });
      } else {
        axios.defaults.headers.common["filterEnc"] = "";
      }
    },
    clearFilterEncrypted() {
      axios.defaults.headers.common["filterEnc"] = "";
    },
    callcanDisabledTargetFn() {
      return this.canHideSchPlanGlbSaveButton;
    },
    callProgramRowFn() {
      return this.addProgramRowData;
    },
    constantValueCallFn() {
      return CONSTANT_VALUE;
    },
    async triggerExportErrorCatchFn(err, name, component) {
      return new Promise((resolve, reject) => {
        try {
          this.showLoader = false;
          const fileNameWithExt =
            err?.response.data && err?.response.data.fileName
              ? `${err?.response.data.fileName}`
              : "";
          let data = err?.response?.data?.data.map((item, index) => {
            if (component === "specificPartner") {
              const data = {
                id: index + 1,
                partnerCode: item.code,
                partnerName: item.name,
                partnerTypeCode: item.groupType,
                ...item,
              };
              return data;
            } else if (component === "soldToPartner") {
              const data = {
                id: index + 1,
                partnerCode: item.code,
                partnerName: item.name,
                groupType: item.groupType,
                ...item,
              };
              return data;
            } else if (component === "specificModal") {
              const data = {
                id: index + 1,
                productName: item.param4Desc,
                productCode: item.param4Value,
              };
              return data;
            } else if (component === "specificProduct") {
              const data = { ...item, id: index + 1 };
              return data;
            } else if (component === "getDetailIsPartner") {
              const data = { ...item };
              return data;
            } else if (component === "getDetailIsProduct") {
              const data = { ...item };
              return data;
            }
          });
          const fullFileName = fileNameWithExt ? `${fileNameWithExt}` : null;
          if (fileNameWithExt)
            triggerExport(name, { fileNameWithExt }, null, fullFileName);
          this.$refs.file.value = "";
          if (
            ["specificModal", "specificProduct"].includes(component) &&
            err.response.status == CONSTANT_VALUE.ERROR_EXCEL_CODE
          ) {
            this.commonExportCSV(err.response, name);
            this.filename = "";
            this.setSnackbar({
              active: true,
              msg: CONSTANT_MESSAGE.EXCEL_ERROR,
            });
            return;
          }
          this.setSnackbar({
            active: true,
            msg: err.response.data.message,
          });
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    momentDateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
  },
};
